<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >
        <CForm>
            <CRow>
              <CCol md="12">
                <b>¿Estás seguro de que deseas <strong>ELIMINAR</strong> todos los Objetivos?</b>
                <br />
                <br />
                <i>Este proceso eliminará todas los objetivos del Concurso.</i>
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="reset" :color="color">Reiniciar</CButton>
        </template>
    </CModal>
</template>

<script>

export default {
  name: 'DeleteAllObjectivesModal',
  props: {

  },
  data () {
    return {
      showModal: false,
      title: "Reiniciar Objetivos",
      color: "danger",
    }
  },
  mounted: async function() {
    
  },
  methods: {
    showResetModal () { 
      this.showModal = true;
      this.color = "danger";
      this.title = 'Reiniciar Objetivos';
    },
    reset () {
      this.$emit("deleteAllObjectives");
      this.closeModal();
    },
    closeModal () {
      this.showModal = false;
    },
  },
}
</script>